<script>
import appConfig from "@/app.config";
import { layoutMethods, reportsMethods, reportsComputed } from "@/state/helpers";
import Swal from "sweetalert2";

export default {
  page: {
    title: "Top-up Transaction Details",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      transactionId: "",
      transView: {
        id: '',
        type: '',
        data: {
          amount: 0,
          fee: 0,
          net_amount: 0,
          status: '--',
          failed_message: "--",
          service_fee: 0
        }
      },
      transDetails: {
        id: 0,
        userId: 0,
        transactionId: "--",
        wallet: "--",
        amount: 0,
        topupValue: 0,
        paymentMethod: "--",
        date: "",
        updated_at: "",
        customerInfo: {
          userId: 0,
          businessId: 0,
          name: "--",
          businessName: "--",
          mobile: "--",
          email: "--",
          address: "--"
        }
      },
      searchValue: {
        searchField: null,
        search: "",
        status: null,
        dateRange: null,
        payment_method: null,
        sort: 'id',
        orderDesc: true
      },
      params: {}
    };
  },
  mounted: async function () {
    this.transactionId = this.$route.params.id
    this.changeTitle({ title: "Topup Transaction Details" });
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: "Peddlr", to: { name: "Home" } },
        { text: "Report", to: { name: "Report" } },
        { text: "Topup Transaction", to: { name: "Topup Transaction" } },
        { text: this.transactionId, to: { name: "Transation ID" } },
      ],
    });
    await this.getTopupLogById()
      .then(async () => {
        // if payment method not kankolek, we will fetch other txn details from paymongo
        if (this.transDetails.paymentMethod.toLowerCase() != 'kankolek') {  
          await this.fetchTransactionDetails();
        }
      });
  },
  computed: {
    ...reportsComputed
  },
  methods: {
    ...layoutMethods,
    ...reportsMethods,
    /*
      Description: fetchTransactionDetails will fetch the transaction details from Paymongo 
                   and will then set the fetched data to this.transView
      Params: this.transactionId
    */
    async fetchTransactionDetails() {
      this.fetchPaymongoTransaction({ transactionId: this.transactionId })
        .then((response) => {
          this.transView = {
            data: response.attributes,
            id: response.id,
            type: response.type
          }
        })
        .catch((err) => {
          Swal.fire("Error!", `An error occured for fetching Paymongo Source Transaction: ${err}`, "error");
          console.log(err);
        });
    },
    /*
      Created by: Jero Balucas
      Created at: Nov 21, 2022
      Description: getTopupLogById will fetch the topup transaction details by transaction id
      Params: this.transactionId
    */
    getTopupLogById: async function () {
      this.searchValue.search = this.transactionId;
      this.params = {
        page: 1,
        rows: 1,
        ...this.searchValue
      };
      await this.getTopupLogs(this.params);
      this.transDetails = this.topupLogs[0];
    },
    /*
      Description: getStatusTransClassColor will set the text color based on status
      Params: data = this.transView.data.status
    */
    getStatusTransClassColor(status) {
      if (this.transDetails.paymentMethod.toLowerCase() != 'kankolek') {
        return status === 'EXPIRED' ? 'text-danger fw-medium m-0' : status === 'PAID' ? 'text-success fw-medium m-0' : 'text-warning fw-medium m-0';
      }
      return status === 'FAILED' ? 'text-danger fw-medium m-0' : status === 'SUCCESS' ? 'text-success fw-medium m-0' : 'text-warning fw-medium m-0';
    }
  },
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-xl-3">
        <!-- Merchant Details card -->
        <div class="card">
          <div class="card-body">
            <div class="d-flex mb-3 border-bottom pb-2 text-dark">
              <div class="flex-grow-1 my-auto">
                <span class="align-middle fw-semibold">Merchant Details</span>
              </div>
            </div>
            <ul class="list-unstyled mb-0 mt-4">
              <li class="pb-2">
                <div class="d-flex align-items-center">
                  <div class="font-size-20 text-secondary flex-shrink-0 me-3">
                    <i class="bx bx-user-circle"></i>
                  </div>
                  <div class="flex-grow-1">
                    <p class="mb-1 font-size-13 fw-semibold">Name</p>
                    <h5 class="mb-0 font-size-14 fw-normal">{{ transDetails.customerInfo.name }}</h5>
                  </div>
                </div>
              </li>
              <li class="pb-2">
                <div class="d-flex align-items-center">
                  <div class="font-size-20 text-secondary flex-shrink-0 me-3">
                    <i class="bx bx-mobile-alt"></i>
                  </div>
                  <div class="flex-grow-1">
                    <p class="mb-1 font-size-13 fw-semibold">Mobile Number</p>
                    <h5 class="mb-0 font-size-14 fw-normal">{{ transDetails.customerInfo.mobile }}</h5>
                  </div>
                </div>
              </li>
              <!-- end li -->
              <li class="py-2">
                <div class="d-flex align-items-center">
                  <div class="font-size-20 text-secondary flex-shrink-0 me-3">
                    <i class="bx bx-envelope"></i>
                  </div>
                  <div class="flex-grow-1">
                    <p class="mb-1 font-size-13 fw-semibold">Email</p>
                    <h5 class="mb-0 font-size-14 fw-normal">{{ transDetails.customerInfo.email }}</h5>
                  </div>
                </div>
              </li>
              <!-- end li -->
              <li class="py-2">
                <div class="d-flex align-items-center">
                  <div class="font-size-20 text-secondary flex-shrink-0 me-3">
                    <i class="bx bx-receipt"></i>
                  </div>
                  <div class="flex-grow-1">
                    <p class="mb-1 font-size-13 fw-semibold">Business Name</p>
                    <h5 class="mb-0 font-size-14 fw-normal">{{ transDetails.customerInfo.businessName }}</h5>
                  </div>
                </div>
              </li>
              <!-- end li -->
            </ul>
          </div>
        </div>
        <!-- end Merchant Details card -->
      </div>
      <!-- end col -->

      <div class="col-xl-9">
        <div class="row">
          <div class="col-lg-12">
            <!-- Transaction Details card -->
            <div class="card">
              <div class="card-body">
                <div class="d-flex mb-3 border-bottom pb-2 text-dark">
                  <div class="flex-grow-1 my-auto">
                    <span class="align-middle fw-semibold">Transaction Details</span>
                  </div>
                </div>
                <div class="row">
                  <form>
                    <div class="row">
                      <div class="col-lg-8">
                        <div class="row m-b-9">
                          <div class="col-4">
                            <p class="font-size-13 fw-semibold">Wallet:</p>
                          </div>
                          <div class="col-8">
                            <p class="font-size-13">{{ transDetails.wallet }}</p>
                          </div>
                        </div>
                        <div class="row m-b-9">
                          <div class="col-4">
                            <p class="font-size-13 fw-semibold">Payment Method:</p>
                          </div>
                          <div class="col-8">
                            <p class="font-size-13">{{ transDetails.paymentMethod }}</p>
                          </div>
                        </div>
                        <!-- Removed this field due to ticket: https://peddlr.atlassian.net/browse/PEDDLR-5413
                        <div class="row m-b-9">
                          <div class="col-4">
                            <p class="font-size-13 fw-semibold">Amount:</p>
                          </div>
                          <div class="col-8">
                            <p class="font-size-13">PHP {{ transDetails.amount   |  numberWithCommas  }}</p>
                          </div>
                        </div> -->
                        <div class="row m-b-9">
                          <div class="col-4">
                            <p class="font-size-13 fw-semibold">Top-up Amount Value:</p>
                          </div>
                          <div class="col-8">
                            <p class="font-size-13">PHP {{ transDetails.topupValue   |  numberWithCommas  }}</p>
                          </div>
                        </div>
                        <div class="row m-b-9">
                          <div class="col-4">
                            <p class="font-size-13 fw-semibold">Rebate:</p>
                          </div>
                          <div class="col-8">
                            <p class="font-size-13">PHP {{ transDetails.rebate   |  numberWithCommas  }}</p>
                          </div>
                        </div>
                        <div class="row m-b-9">
                          <div class="col-4">
                            <p class="font-size-13 fw-semibold">Date:</p>
                          </div>
                          <div class="col-8">
                            <p class="font-size-13">{{ transDetails.date | formatDate }}</p>
                          </div>
                        </div>
                        <div class="row m-b-9">
                          <div class="col-4">
                            <p class="font-size-13 fw-semibold">Transaction ID:</p>
                          </div>
                          <div class="col-8">
                            <p class="font-size-13">{{ transDetails.transactionId }}</p>
                          </div>
                        </div>
                        <div class="row m-b-9">
                          <div class="col-4">
                            <p class="font-size-13 fw-semibold">Error Description:</p>
                          </div>
                          <div class="col-8">
                            <p class="font-size-13">{{ transView.data.failed_message }}</p>
                          </div>
                        </div>
                        <div class="row m-b-9">
                          <div class="col-4">
                            <p class="font-size-13 fw-semibold">Net Fee:</p>
                          </div>
                          <div class="col-8">
                            <p class="font-size-13">PHP {{ transView.data.net_amount != null ? (transView.data.net_amount / 100).toFixed(2) : '0.00' }}</p>
                          </div>
                        </div>
                        <div class="row m-b-9">
                          <div class="col-4">
                            <p class="font-size-13 fw-semibold">Fee:</p>
                          </div>
                          <div class="col-8">
                            <p class="font-size-13">PHP {{ transView.data.fee != null ? (transView.data.fee / 100).toFixed(2) : '0.00' }}</p>
                          </div>
                        </div>
                        <div class="row m-b-9">
                          <div class="col-4">
                            <p class="font-size-13 fw-semibold">Service Fee:</p>
                          </div>
                          <div class="col-8">
                            <p class="font-size-13">PHP {{ (transDetails?.service_fee ?? 0)  |  numberWithCommas }}</p>
                          </div>
                        </div>
                        <div class="row m-b-9">
                          <div class="col-4">
                            <p class="font-size-13 fw-semibold">Status:</p>
                          </div>
                          <div class="col-8">
                            <p class="font-size-13" v-if="transDetails.paymentMethod.toLowerCase() != 'kankolek'">
                              <span :class="getStatusTransClassColor(transView.data.status.toUpperCase())"> {{
                                  transView.data.status.toUpperCase()
                              }}</span>
                            </p>
                            <p class="font-size-13" v-else>
                              <span :class="getStatusTransClassColor(transDetails.status.toUpperCase())"> {{
                                  transDetails.status.toUpperCase()
                              }}</span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- hidden -->
                  </form>
                </div>
              </div>
            </div>
            <!-- end Transaction Details card -->
          </div>
        </div>
        <!-- end row -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </div>
</template>
